import { RouteName } from "../RouteNames";

export const socialMediaRoutes = [
  {
    name: RouteName.SocialMediaLocked,
    path: "locked-socials",
    component: () =>
      import("@follaw-fr/views/side_menu_views/LockedSocials.vue"),
  },
  {
    name: RouteName.SocialMediaOverview,
    displayName: "Vue d'ensemble",
    path: "overview",
    component: () =>
      import("@follaw-fr/views/side_menu_views/SocialMediaOverviewView.vue"),
  },
  {
    name: RouteName.SocialMediaPublications,
    path: "posts",
    component: () =>
      import("@follaw-fr/views/side_menu_views/SocialMediaPostsView.vue"),
  },

  {
    name: RouteName.SocialMediaPublicationsFollawed,
    path: "posts/follawed",
    component: () =>
      import("@follaw-fr/views/side_menu_views/SocialMediaPostsView.vue"),
  },
];
